import * as actionType from "./action";

const initialState = {
  shoppingList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_SHOP_LIST:
      return {
        ...state,
        shoppingList: action.payload,
      };
    case actionType.ADD_NEW_SHOP_LIST: {
      const shoppingList = [...state.shoppingList];
      shoppingList.push(action.payload);
      return {
        ...state,
        shoppingList,
      };
    }
    case actionType.DELETE_SHOP_LIST: {
      const shoppingList = state.shoppingList.filter(
        (list) => list.id !== action.payload,
      );
      return {
        ...state,
        shoppingList,
      };
    }
    case actionType.DELETE_ALL_SHOP_LIST: {
      return {
        ...state,
        shoppingList: [],
      };
    }
    case actionType.UPDATE_SHOP_LIST_NAME:
      return {
        ...state,
        shoppingList: state.shoppingList.map((list) =>
          list.id === action.payload.id ? action.payload : list,
        ),
      };
    case actionType.LOGOUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
export default reducer;
